import { Calculator, Play } from 'lucide-react';
import { Product } from './types';
import { normalizeProductPricing } from './pricingNormalization';

export const completePayrollSystem: Product = normalizeProductPricing({
  id: 'complete-payroll-system',
  title: 'Complete Payroll System',
  subtitle: 'AI-Powered Global Payroll Platform',
  description: 'Enterprise-grade payroll solution with AI automation, global compliance, and seamless employee self-service across 180+ countries, optimised for UK businesses with full HMRC integration.',
  icon: Calculator,
  image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  category: 'Human Resources',
  status: 'Live',
  businessTypes: ['#enterprise', '#multinational', '#hr', '#payroll', '#compliance', '#global-workforce'],
  features: [
    'AI-powered payroll automation and error detection for UK businesses',
    'Global payroll processing across 180+ countries with UK HMRC integration',
    'Advanced tax compliance and regulatory automation including UK IR35',
    'Employee self-service portal with mobile app & UK pension integration',
    'Time & attendance integration with biometric support & UK working time regulations',
    'Benefits administration and enrollment management',
    'Real-time payroll analytics and reporting',
    'Multi-currency and exchange rate management',
    'Direct deposit and multiple payment methods',
    'Automated tax filing and regulatory reporting',
    'Custom pay schedules and payroll calendars',
    'Integration with 200+ HR and accounting systems',
    'Advanced security with SOC 2 Type II compliance',
    'Audit trails and compliance documentation',
    'Payroll forecasting and budget planning',
    'Employee onboarding and offboarding automation',
    'Expense management and reimbursement processing',
    "Workers' compensation and insurance management",
    'Performance-based compensation and bonuses',
    'Compliance alerts and regulatory updates',
    'Custom reporting and dashboard creation',
    'API access for custom integrations',
    'White-label and co-branding options',
    '24/7 multi-language support and training',
  ],
  pricing: {
    setup: 28800,
    monthly: 699,
  },
  color: 'from-emerald-500 to-green-600',
  demoConfig: {
    type: 'interactive',
    url: '/payroll/demo',
    title: 'Experience the Complete Platform',
    description: 'Discover our AI-powered global payroll system with multi-country compliance and real-time processing',
    buttonText: 'Launch Payroll Demo',
    icon: Play,
    buttonColor: 'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700',
  },
});
